import { render, staticRenderFns } from "./certificatePage.vue?vue&type=template&id=999c4ede&scoped=true"
import script from "./certificatePage.vue?vue&type=script&lang=js"
export * from "./certificatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999c4ede",
  null
  
)

export default component.exports